import {OpenCheckTypes} from 'types/api/api-models';

export const actions = {
  DELETE: 'DELETE',
  UPSERT: 'UPSERT',
  GET: 'GET',
  LIST: 'LIST',
  GET_QUEUES: 'GET_QUEUES',
  GET_NUMBERS: 'GET_NUMBERS',
  GET_TIMEZONES: 'GET_TIMEZONES',
  LOADING_HOURS: 'LOADING_HOURS',
  DELETING_HOURS: 'DELETING_HOURS',
  SET_ERROR: 'SET_ERROR',
  SET_MESSAGE: 'SET_MESSAGE',
  ADD_ASSOCIATION_KEY: 'ADD_ASSOCIATION_KEY',
  REMOVE_ASSOCIATION_KEY: 'REMOVE_ASSOCIATION_KEY',
};

export function hoursReducer(state: any, action: any) {
  switch (action.type) {
    case actions.DELETE: {
      // @todo Potentially remove menu from list instead of listing again
      return {
        ...state,
        deletingHours: false,
      };
    }
    case actions.DELETING_HOURS: {
      // @todo Potentially remove menu from list instead of listing again
      return {
        ...state,
        deletingMenu: action.payload,
      };
    }
    case actions.UPSERT: {
      // @todo Potentially append menu in list instead of listing again
      return state;
    }
    case actions.LOADING_HOURS: {
      return {
        ...state,
        loadingHours: action.payload,
      };
    }
    case actions.LIST: {
      return {
        ...state,
        hoursLoaded: true,
        loadingHours: false,
        associationsObj: {
          [OpenCheckTypes.QUEUE]: [],
          [OpenCheckTypes.DNIS]: [],
          [OpenCheckTypes.CUSTOM]: [],
        },
        hoursList: action.payload.hoursList,
      };
    }
    case actions.GET_QUEUES:
      return {
        ...state,
        queuesLoaded: true,
        queues: action.payload.queues,
      };
    case actions.GET_NUMBERS:
      return {
        ...state,
        numbersLoaded: true,
        numbers: action.payload.numbers,
      };
    case actions.GET_TIMEZONES:
      return {
        ...state,
        timezonesLoaded: true,
        timezones: action.payload.timezones,
      };
    case actions.SET_ERROR:
      return {
        ...state,
        error: action.payload.error,
      };
    case actions.SET_MESSAGE:
      return {
        ...state,
        msg: action.payload.msg,
      };
    case actions.ADD_ASSOCIATION_KEY: {
      let idx = state.associationsObj[action.payload.type].indexOf(
        action.payload.key,
      );
      if (idx !== -1)
        return {
          ...state,
        };
      state.associationsObj[action.payload.type].push(action.payload.key);
      return {
        ...state,
        associationsObj: {
          ...state.associationsObj,
          [action.payload.type]: state.associationsObj[action.payload.type],
        },
      };
    }
    case action.REMOVE_ASSOCIATION_KEY: {
      let idx = state.associationsObj[action.payload.type].indexOf(
        action.payload.key,
      );
      if (idx === -1)
        return {
          ...state,
        };
      state.associationsObj[action.payload.type].splice(idx, 1);
      return {
        ...state,
        associationsObj: {
          ...state.associationsObj,
          [action.payload.type]: state.associationsObj[action.payload.type],
        },
      };
    }

    default:
      return state;
  }
}
